import { createApiRef } from '@backstage/core-plugin-api';

// ── Types ───────────────────────────────────────────────────────────────────

export type QualityEntityType = 'Project' | 'QualityGate' | 'Rules';

export interface GenerateRequest {
  entityType: QualityEntityType;
  prompt: string;
}

export interface GenerateResponse {
  content: string;
  parsedIntent: Record<string, unknown> | null;
  warnings: string[];
}

export interface ExecuteRequest {
  templateName: string;
  values: Record<string, unknown>;
}

export interface ExecuteResponse {
  id: string;
  [key: string]: unknown;
}

export interface SonarProject {
  key: string;
  name: string;
  qualifier: string;
  visibility: string;
  lastAnalysisDate?: string;
}

export interface SonarQualityGate {
  id: number;
  name: string;
  isDefault: boolean;
  isBuiltIn: boolean;
  conditions?: Array<{ id: number; metric: string; op: string; error: string }>;
}

export interface SonarRule {
  key: string;
  name: string;
  severity: string;
  lang: string;
  type: string;
  status: string;
}

// ── API interface ───────────────────────────────────────────────────────────

export interface QualityStudioApi {
  generate(request: GenerateRequest): Promise<GenerateResponse>;
  execute(request: ExecuteRequest): Promise<ExecuteResponse>;
  listProjects(): Promise<SonarProject[]>;
  listQualityGates(): Promise<SonarQualityGate[]>;
  listRules(language?: string): Promise<SonarRule[]>;
}

export const qualityStudioApiRef = createApiRef<QualityStudioApi>({
  id: 'plugin.quality-studio.api',
});
